
























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { namespace } from 'vuex-class';
import { BottomWrapper } from '../../BottomWrapper.vue';
import { PayChannelSuccessRate, TransStatement } from '@/common/api/model';
import { SYSTEM_MESSAGE_PREFIX, TransactionType } from '@/common/config';
import { formatMoney } from '@/common/utils';
import { ChatWarning, TransactionInputEvent } from '@/common/types';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';
import RadioFilled from '@/components/icons/RadioFilled.vue';
import RadioEmpty from '@/components/icons/RadioEmpty.vue';
import TransactionItemWarning from './TransactionItemWarning.vue';
import UpdatedStatusWarning from './UpdatedStatusWarning.vue';
import { TRANSACTION_PREPOSITION_ENUM, TRANSACTION_STATUS_ENUM, TRANSACTION_STATUS_NAME_ENUM, TransactionStatusName, UpdatedStatusWarningVariant, checkTransactionWarning } from '@/common/transaction-utils';
import { ExternalTransactionKind, ExternalTransactionType } from '@/common/bot/enum/ExternalTransactionType';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { Bridge } from '@/common/bridge';
import { PLEASED_ARTICLE_ACTIONS } from '@/common/bot/flow-frameworks/ChatMessageActions.static';
import { GA_EVENT_CUSTOM_DIMENSION_ENUM, GA_EVENT_NAME_ENUM } from '@/common/gaHelper';
import { ChatWarnings } from '@/store/chatWarning/chatWarning.types';
import * as PleasedModel from '@/common/api/models.pleased';
import { ConnectToAgent } from '@/common/bot/types';
import { reportingService } from '@/common/reporting';
import * as PleasedApi from '@/common/api/api.pleased';

const userModule = namespace('user');
const chatModule = namespace('chat');
const transactionModule = namespace('transaction');
const chatWarning = namespace('chatWarning');

@Component({
  components: {
    Input,
    BottomWrapper,
    FaCheckSquare,
    FaRegSquare,
    FaAngleRight,
    RadioFilled,
    RadioEmpty,
    TransactionItemWarning,
    UpdatedStatusWarning,
  },
  filters: {
    formatDate (value: any) {
      const options = { hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatDay (value: any) {
      const options = { hour12: false, year: 'numeric', month: 'numeric', day: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatTime (value: any) {
      const options = { hour12: false, hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatMoney (value: number) {
      return formatMoney(value);
    },
  },
})
export default class Transaction extends Vue {
  @Prop({ default: () => ([]) }) readonly transactions!: TransStatement[];
  @Prop({ default: null }) readonly transactionsSavedData!: TransactionInputEvent | null;
  @Prop({ default: '' }) readonly transactionType!: TransactionType
  @Prop({ default: null }) readonly externalTransactionKinds!: ExternalTransactionKind[];
  @Prop() readonly transactionMethodSuccessRate!: PayChannelSuccessRate[] | null;

  @userModule.Getter('currency') currency!: string;
  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;
  @chatWarning.Getter('chatWarnings') chatWarnings!: ChatWarnings;
    @Prop() readonly connectConfig!: ConnectToAgent | null;

  @Prop({ default: () => [] }) readonly openRequestFields!: PleasedModel.TicketField[];
  @Prop({ default: () => ({ subject: '', description: '', email: '' }) }) readonly requestInfo!: { subject: string, description: string, email: string };
  @Prop({ default: () => [] }) readonly userSelections!: {message: string; timestamp: string}[]

  @transactionModule.State('selectedTransactions') selectedTransactions!: TransStatement[];

  @transactionModule.Getter('transactionStatusFlags') transactionStatusFlags!: {
    isCheckingStatusForTransaction: boolean;
    showTransactionUpdatedWarning: boolean;
    shouldCheckStatusForDeposit: boolean;
    isTransactionStatusUpdatedSuccessfully: boolean;
  };
  @transactionModule.Getter('updatedTransactionsLength') updatedTransactionsLength!: number;
  @transactionModule.Getter('allSelectedTransactionsUpdated') allSelectedTransactionsUpdated!: boolean;
  @transactionModule.Getter('hasOnlyPendingUpdatedTransactions') hasOnlyPendingUpdatedTransactions!: boolean;
  @transactionModule.Getter('hasOnlySuccessfulUpdatedTransactions') hasOnlySuccessfulUpdatedTransactions!: boolean;
  @transactionModule.Getter('getUpdatedTransactionStatus') getUpdatedTransactionStatus!:(tx: TransStatement) => TransactionStatusName | null;
  @transactionModule.Getter('updatedTransactionsNotification') updatedTransactionsNotification!: { type: UpdatedStatusWarningVariant, text: string };

  @transactionModule.Action('checkTransactionStatus') checkTransactionStatus!: () => Promise<void>;
  @transactionModule.Mutation('addSelectedTransactions') addSelectedTransactions!: (transactions: TransStatement[]) => void;
  @transactionModule.Mutation('resetSelectedTransactions') resetSelectedTransactions!: () => void;
  @transactionModule.Mutation('setShowTransactionUpdatedWarning') setShowTransactionUpdatedWarning!: (show: boolean) => void;

  readonly TRANSACTION_PREPOSITION_ENUM = TRANSACTION_PREPOSITION_ENUM;
  readonly TRANSACTION_STATUS_ENUM = TRANSACTION_STATUS_ENUM;
  readonly TRANSACTION_STATUS_NAME_ENUM = TRANSACTION_STATUS_NAME_ENUM;

  readonly GA_EVENT_NAME_ENUM = GA_EVENT_NAME_ENUM;
  readonly GA_EVENT_CUSTOM_DIMENSION_ENUM = GA_EVENT_CUSTOM_DIMENSION_ENUM;

  expandedTrans: string[] = [];
  noneSelected: boolean = false;
  sentTransactionWarningTypes: string[] = [];
  sendRemedyShownMetric: boolean = false;

  isTicketCreationTriggered: boolean = false;
  lastCreatedDirectRequest: PleasedModel.TicketDetail | null = null;
  triggerTicketRequestMap: { [key: string]: PleasedModel.ActiveTicket[] } = {};

  errInfo = {
    isErr: false,
    message: '',
  };

  localTransactions: TransStatement[] = [];

  get title () {
    if (this.lastCreatedDirectRequest) {
      return this.$t('page.issue.transaction.title.ticket_created', { ticketId: this.lastCreatedDirectRequest.id }).toString();
    }

    if (this.isNoRecord) {
      return this.$t('page.issue.transaction.none');
    }

    const iSingleExternalTransactionType = this.externalTransactionKinds.length === 1;

    const transactionTypeTitle = iSingleExternalTransactionType
      ? this.$t(
        `page.issue.transaction.title.${this.externalTransactionKinds[0].toLowerCase()}`
      )
      : this.$t('page.issue.transaction.title.transaction');

    return `${this.$t('page.issue.transaction.title.select')} ${transactionTypeTitle}`;
  }

  get selectedTransactionWithWarnings () {
    const transactionWarnings = (this.selectedTransactions || []).map((transaction) => checkTransactionWarning({
      transaction,
      transactionMethodSuccessRate: this.transactionMethodSuccessRate,
      type: this.transactionType,
      chatWarnings: this.chatWarnings,
    }));

    return transactionWarnings.filter((warning) => warning.show);
  }

  get isSelectedTransactionWithWarning () {
    return !!this.selectedTransactionWithWarnings.length;
  }

  get checkDepositStatusLoaderText () {
    return this.$tc('page.issue.transaction.checking_deposit_status', this.selectedTransactions.length);
  }

  get isPendingDepositTransactions () {
    return this.externalTransactionKinds.includes(ExternalTransactionType.DEPOSITS_PENDING);
  }

  get triggerTicketCreation () {
    const { triggerTicketCreation } = this.connectConfig || {};

    return !!triggerTicketCreation && this.selectedTransactions.length > 0;
  }

  get ticketCreationResponseMessage () {
    return this.connectConfig?.ticketCreationResponseMessage;
  }

  get triggerTicketCreationError () {
    if (!this.triggerTicketCreation) {
      return '';
    }

    const isSelectedTransactionAlreadyReported = this.selectedTransactions.some((tx) => {
      const { tradeId } = tx;
      return this.triggerTicketRequestMap[tradeId]?.length > 0;
    });

    if (isSelectedTransactionAlreadyReported) {
      return this.$t('page.issue.transaction.duplicate_direct_ticket_error').toString();
    }

    return '';
  }

  get isSingleTransactionSelectMode () {
    const { triggerTicketCreation } = this.connectConfig || {};

    // if triggerTicketCreation is not set, then we don't need to check
    // for unsettled bet limitation (1 transaction per request)
    return !!triggerTicketCreation;
  }

  get buttons () {
    const proceedButton = {
      name: this.isSelectedTransactionWithWarning ? this.$t('page.issue.transaction.proceed_anyway') : this.$t('page.guest.button.proceed'),
      id: 'proceed' as const,
      className: this.isSelectedTransactionWithWarning ? 'secondary' : '',
      disabled: !this.canProceed,
    };

    const checkStatusButton = {
      name: this.$tc('page.issue.transaction.check_deposit_status', this.selectedTransactions.length),
      id: 'checkStatus' as const,
    };

    const cancelButton = { name: this.$t('page.issue.transaction.cancel_request'), id: 'cancel' as const };
    const transactionsButton = { name: this.$t('page.issue.transaction.transactions'), id: 'transactions' as const, appendIcon: FaAngleRight };
    const contactSupportButton = { name: this.$t('page.issue.transaction.contact_support'), id: 'proceed' as const, className: !this.hasOnlyPendingUpdatedTransactions ? 'secondary' : '' };
    const needMoreHelpButton = {
      // TODO: make separate row in i18n
      name: this.$t('article.feedback.button.need_more_help'),
      id: 'go-to-ticket',
      isActive: false,
      className: 'secondary',
    };
    const endChatButton = { name: this.$t('global.end_chat'), id: 'end-chat' as const, isActive: true };

    if (this.isTicketCreationTriggered) {
      if (this.errInfo.isErr) {
        return [
          endChatButton,
        ];
      }

      return [needMoreHelpButton, endChatButton];
    }

    if (this.triggerTicketCreation) {
      if (this.triggerTicketCreationError) {
        return [
          endChatButton,
        ];
      }

      return [{
        name: this.$t('page.issue.transaction.submit_request'),
        id: 'direct-trigger-ticket-creation',
        isActive: true,
      }];
    }

    if (this.hasOnlySuccessfulUpdatedTransactions) {
      return [transactionsButton];
    }

    if (this.transactionStatusFlags.shouldCheckStatusForDeposit) {
      return [checkStatusButton];
    }

    if (this.hasOnlyPendingUpdatedTransactions) {
      return [contactSupportButton];
    }

    if (this.allSelectedTransactionsUpdated) {
      return [contactSupportButton, transactionsButton];
    }

    return [
      proceedButton,
      ...(this.isSelectedTransactionWithWarning ? [cancelButton] : []),
    ];
  }

  get actionType () {
    return TransactionType[this.transactionType];
  }
  get preposition () {
    return this.TRANSACTION_PREPOSITION_ENUM[this.transactionType];
  }
  get isNoRecord () {
    return this.transactions.length === 0;
  }
  get canProceed () {
    return this.selectedTransactions.length || this.noneSelected || this.isNoRecord;
  }
  get operator () {
    return this.transactionType === TransactionType.Deposit ? '+' : '-';
  }
  get isDepositList () {
    return this.transactionType === TransactionType.Deposit;
  }

  get transactionsToShow () {
    return this.localTransactions.length ? this.localTransactions : this.transactions;
  }

  get defaultRemedyGaParams () {
    const { isTransactionStatusUpdatedSuccessfully } = this.transactionStatusFlags;

    return {
      event_category: 'Transaction',
      ...(isTransactionStatusUpdatedSuccessfully !== null
        ? {
          [this.GA_EVENT_CUSTOM_DIMENSION_ENUM.REMEDY_TRANSACTION_UPDATED_SUCCESSFULLY]: isTransactionStatusUpdatedSuccessfully,
        }
        : {}),
    };
  }

  created () {
    document.title = 'Transactions';

    if (this.transactionsSavedData) {
      this.resetSelectedTransactions();
      this.addSelectedTransactions(this.transactionsSavedData.selectedTransIssue);
    }

    const key = `local_tx_${this.transactionType === TransactionType.Deposit ? 'deposits' : 'withdrawals'}`;
    const localTransactions = JSON.parse(localStorage.getItem(key) || '[]');
    this.localTransactions = localTransactions;
  }

  selectTransaction (transaction: TransStatement) {
    this.noneSelected = false;
    this.addSelectedTransactions([transaction, ...(this.isSingleTransactionSelectMode ? [...this.selectedTransactions] : [])]);
  }

  expandTrans (tradeId: string) {
    const index = this.expandedTrans.indexOf(tradeId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(tradeId);
    }
  }

  selectNone () {
    if (this.noneSelected) {
      this.noneSelected = false;
    } else {
      this.resetSelectedTransactions();
      this.noneSelected = true;
    }
  }

  isTransactionSelected (transaction: TransStatement) {
    return this.selectedTransactions.some((item) => item.tradeId === transaction.tradeId);
  }

  goToTransactions () {
    Bridge.goToAction(PLEASED_ARTICLE_ACTIONS.GO_TRANSACTIONS);
  }

  proceed (selectedButton: { id: string }) {
    if (selectedButton.id === 'cancel') {
      if (this.isSelectedTransactionWithWarning) {
        // take first warning
        const transactionWarning = this.selectedTransactionWithWarnings[0];

        this.$gtag.event(this.GA_EVENT_NAME_ENUM.CANCEL_REQUEST_TRANSACTION_WARNING, {
          'event_category': 'Transaction',
          [this.GA_EVENT_CUSTOM_DIMENSION_ENUM.TRANSACTION_WARNING_TYPE]: transactionWarning.type,
        });
      }

      this.$emit('support-request:cancel');
      return;
    }

    if (selectedButton.id === 'end-chat') {
      this.$emit('end-chat');
      return;
    }

    if (selectedButton.id === 'direct-trigger-ticket-creation') {
      this.directTriggerTicketCreation();
      return;
    }

    if (selectedButton.id === 'go-to-ticket') {
      this.$emit('open-active-conversation', this.lastCreatedDirectRequest);
      return;
    }

    if (selectedButton.id === 'checkStatus') {
      this.$gtag.event(this.GA_EVENT_NAME_ENUM.REMEDY_TRANSACTION_RUN, this.defaultRemedyGaParams);
      this.checkTransactionStatus();
      return;
    }

    if (selectedButton.id === 'transactions') {
      if (this.updatedTransactionsLength > 0) {
        this.$gtag.event(this.GA_EVENT_NAME_ENUM.GO_TO_TRANSACTIONS_AFTER_REMEDY, this.defaultRemedyGaParams);
      }

      this.goToTransactions();
      return;
    }

    const issueMsg = this.selectedTransactions.reduce((acc: string[], cur) => {
      const authority = cur.counterAuthority ? cur.counterAuthority : cur.counterFull;
      const msg = `${this.actionType} ${authority ? this.preposition : ''} ${authority || ''} ${formatMoney(cur.amount)} ${this.currency} (transaction id: ${cur.tradeId})`;
      return [...acc, msg];
    }, []);

    const data = [{
      extraFieldKey: 'Transaction',
      extraFieldValue: this.selectedTransactions.reduce((acc, cur) => {
        const msg = `${this.actionType} ${this.preposition} ${cur.counterAuthority ? cur.counterAuthority : cur.counterFull} ${formatMoney(cur.amount)} ${this.currency}`;
        return acc ? `${acc} / ${msg}` : `${msg}`;
      }, ''),
    }, {
      extraFieldKey: 'Transaction ID',
      extraFieldValue: this.selectedTransactions.reduce((acc, cur) => acc ? `${acc} / ${cur.tradeId}` : `${cur.tradeId}`, ''),
    }];
    this.updateExtraTransactionInfo(data);

    if (!this.canProceed) return;

    if (this.updatedTransactionsLength > 0) {
      this.$gtag.event(this.GA_EVENT_NAME_ENUM.CONTACT_SUPPORT_AFTER_REMEDY, this.defaultRemedyGaParams);
    }

    this.emitTransactionInput({ issueMsg, data });
  }

  emitTransactionInput ({ issueMsg, data }: {issueMsg: string[], data: {
    extraFieldKey: string;
    extraFieldValue: string;
  }[]}) {
    const $event: TransactionInputEvent = { type: this.transactionType, issues: issueMsg, none: this.noneSelected, meta: data, empty: this.isNoRecord, selectedTransIssue: this.selectedTransactions };
    this.$emit('transaction:input', $event);
  }

  getSelectionIssueText (transaction: TransStatement) {
    const authority = transaction.counterAuthority ? transaction.counterAuthority : transaction.counterFull;
    const msg = `${this.actionType} ${authority ? this.preposition : ''} ${authority || ''} ${formatMoney(transaction.amount)} ${this.currency} (transaction id: ${transaction.tradeId})`;

    return msg;
  }

  async directTriggerTicketCreation () {
    const { category, title } = this.connectConfig || {};
    const transactionId = this.selectedTransactions[0].tradeId;

    const openedTickets = await PleasedApi.getActiveConversations({ onlyActive: true, transactionId });

    if (openedTickets.tickets.length > 0) {
      Vue.set(this.triggerTicketRequestMap, transactionId, openedTickets.tickets);
      return;
    }

    reportingService.openRequestClicked();

    const transactionUserSelections = this.selectedTransactions.map((tx) => ({
      timestamp: Date.now(),
      message: `${SYSTEM_MESSAGE_PREFIX} ${this.t('chat.user.issue.part')}: ${this.getSelectionIssueText(tx)}`,
    }));

    // For now we'll support only 1 transaction per request
    const subjectIds = `(Id${this.selectedTransactions.length > 1 ? 's' : ''}: ${this.selectedTransactions.map((tx) => tx.tradeId).join(', ')})`;
    const subject = `${category} - ${title} - ${subjectIds}`;

    PleasedApi.createTicket({
      subject,
      description: 'Direct Ticket Creation Request',
      recipientAddress: this.requestInfo.email,
      ticketFields: this.openRequestFields,
      userSelections: [...this.userSelections, ...transactionUserSelections]
        .map(({ timestamp, message }) => ({ message, createdAt: `${timestamp}` })),
      userLogs: reportingService.getLogs(),
      tags: ['direct_ticket'],
      transactionId,
    }).then((res) => {
      this.lastCreatedDirectRequest = res;
      this.isTicketCreationTriggered = true;
      this.$emit('direct-open-request', res);
    }).catch(e => {
      const error: Error = e;
      this.errInfo.isErr = true;
      this.errInfo.message = error.message;
    });
  }

  @Watch('selectedTransactionWithWarnings')
  onSelectedTransactionWithWarningsChange (transactionWarnings: ChatWarning[]) {
    transactionWarnings.forEach((transactionWarning) => {
      if (transactionWarning && transactionWarning.type && !this.sentTransactionWarningTypes.includes(transactionWarning.type)) {
        this.$gtag.event(this.GA_EVENT_NAME_ENUM.TRANSACTION_WARNING_SHOWN, {
          'event_category': 'Transaction',
          [this.GA_EVENT_CUSTOM_DIMENSION_ENUM.TRANSACTION_WARNING_TYPE]: transactionWarning.type,
        });

        this.sentTransactionWarningTypes.push(transactionWarning.type);
      }
    });
  }

  @Watch('transactionStatusFlags.shouldCheckStatusForDeposit')
  onShouldCheckStatusForDepositChange (shouldCheckStatusForDeposit: boolean) {
    if (shouldCheckStatusForDeposit && !this.sendRemedyShownMetric) {
      this.$gtag.event(this.GA_EVENT_NAME_ENUM.REMEDY_TRANSACTION_SHOWN, this.defaultRemedyGaParams);

      this.sendRemedyShownMetric = true;
    }
  }
}
